import _ from 'lodash';

function ReportController(ReportComponent, Toast, $filter, Auth, $scope, UserComponent, PageHeading, SidebarService, $stateParams) {
	'ngInject';

	const vm = this;
	vm.numberValidation = numberValidation;
	vm.activeUserId =  $stateParams.returnResult.userId || Auth.getCurrentUser().id;
	vm.fetchReports = fetchReports;
	vm.paginationInfo = ReportComponent.getPaginationInfo();
	vm.pageSize = 60;
	vm.query = $stateParams.returnResult.activeUserName || null;
	vm.userId = $stateParams.returnResult.userId || 0;
	vm.getReports = ReportComponent.getReports;
	vm.totalPrice = ReportComponent.getTotalPriceCurrencies;
	vm.getUsers = UserComponent.getUsers;
	vm.fetchUsers = UserComponent.fetchUsers;
	vm.clearResults = UserComponent.clearUsers;
	vm.selectItemFromAutoComplete = selectItemFromAutoComplete;
	vm.adminReports = vm.activeUserId === 1 ? 1 : 0;
	vm.clearSearchResults = clearSearchResults;
	vm.getCommissionCurrencies = ReportComponent.getCommissionCurrencies;
	vm.showTicketType = showTicketType;
	vm.ticketFilter = false;
	vm.ticketNumber = {};
	vm.errors = {};
	vm.filteredReports = [];
	vm.getReportsByNumber = ReportComponent.getReportsByNumber;
	vm.currentFilteredPage = 0;
	vm.reportType = vm.ticketFilter ? 'number' : 'date';
	vm.date = {
		'from': $stateParams.returnResult.date_from || null,
		'to': $stateParams.returnResult.date_to || null
	};
	vm.ticketErrors = {
		'number_from': false,
		'number_to': false
	};
	vm.showResultTable = false;
	vm.unconfirmed = false;
	vm.noResults = false;

	if ( Object.keys($stateParams.returnResult).length === 0 ) {
		ReportComponent.clearReports();
	}

	activate();

	/** Initial activities */
	function activate() {
		const heading = $filter('translate')('SIDEBAR.REPORTS');
		const title = `BTMS | ${$filter('translate')('SIDEBAR.REPORTS')}`;

		PageHeading.setPageHeading(heading, title);

		SidebarService.getCurrentUserRoles()
			.then(function(currentUserRoles) {
				vm.isCurrentUserOwner = _.find(currentUserRoles, {'name': 'owner'});
				vm.isCurrentUserAdministrator = _.find(currentUserRoles, {'name': 'administrator'});
			});
	}

	/** Fetch tickets
	 *@params { Date } - dates from - to
	 *@params { Number } - current page used in pagination
	 *@params { Number } - search ticket by nubers from - to
	*/
	function fetchReports(date, numbers, page) {
		const params = vm.ticketFilter ? numbers : date;
		const paymentSystem = vm.paymentSystem === 1 ? 'epay' : ''; 
		let hasErrors = false;
		// Used because HTML ng-repeater strange behaviour
		vm.showResultTable = false;
		vm.reportType = vm.ticketFilter ? 'number' : 'date';
		vm.unconfirmed = vm.unconfirmed ? 'default' : '';
		vm.noResults = false;

		if ( !vm.ticketFilter ) {
			vm.ticketNumber = {};
		}
		
		// Check if ticket number fields from and to has their values
		if (Object.keys(numbers).length > 1) {
			if ( !searchByTicketNumberValidation() ) {
				hasErrors = true;
			}
		}

		if (hasErrors) {
			Toast.error($filter('translate')('ERRORS.GENERAL'));

			return false;
		}

		if ((vm.isCurrentUserOwner || vm.isCurrentUserAdministrator) && vm.adminReports === 0) {
			vm.activeUserId = vm.userId || 0;
		} else {
			vm.activeUserId = Auth.getCurrentUser().id;
		}


		ReportComponent.fetchReports(vm.activeUserId, params, page, vm.reportType, vm.unconfirmed, 60, paymentSystem)
			.then(function(res) {
				if (res.data && res.data.errors) {
					Toast.responseError(res.data.errors);
				}
				
				if ( res.length === 0 ) {
					vm.noResults = true;
				}

				if (res.hasOwnProperty('tickets')) {
					vm.showResultTable = true;
					generateFilteredResult(res);
				} 
			});
	}

	/** Select agent or ofice by autocomplete field */
	function selectItemFromAutoComplete(result) {
		vm.query = result.name || result.names;
		vm.userId = result.user[0].id;
		vm.adminReports = 0;
	}

	/** Clear results from search */
	function clearSearchResults() {
		vm.query = '';
		vm.userId = '';
	}

	/** Show type of ticket
	 * @params { String } - type of ticket
	 */
	function showTicketType(type) {
		if (type === 'default') {
			return 'NOT_INSPECTED';
		} else {
			let ticketType = '';

			type ? ticketType = type.toUpperCase() : 0;
			// Return locale key have to be in uppercase
			return ticketType;
		}
	}

	/** Validate only numbers
	 * @params { String } - input field value
	 * @e { Object } - event object
	*/
	function	numberValidation(value, e) {
		const regex = /^[0-9]+$/;

		if ( !regex.test(value) ) {
			if (e.target.id === 'startNumber') {
				value ? vm.errors.number_from = true : vm.errors.number_from = false;
			}else {
				value ? vm.errors.number_to = true : vm.errors.number_to = false;
			}
		} else {
			if (e.target.id === 'startNumber') {
				vm.errors.number_from = false;
			}else {
				vm.errors.number_to = false;
			}
		}
	}

	/** Validate from number to be less than to number */
	function searchByTicketNumberValidation() {
		if (vm.errors.number_from || vm.errors.number_to) {
			return false;
		} else {
			let isValidValues = vm.ticketNumber.from < vm.ticketNumber.to;
			const ticketFromNumber = parseInt(vm.ticketNumber.from, 10);
			// Convert vm.ticketNumber.from to integer used in result table in'Ticket' column
			vm.ticketNumber.from = ticketFromNumber;

			if ( !isValidValues ) {
				Toast.error(`Стойноста на полето "От" неможе да е по-голяма то тази на полето "До"`);
			}

			if ( vm.ticketNumber.to > ticketFromNumber  + 1000 ) {
				Toast.error(`Стойноста на полето "До" неможе да е по-голяма то ${ ticketFromNumber + 1000 }`);
				isValidValues = false;
			}

			return isValidValues;
		}
	}

	/** Create reports array filtered by number with empty rows
	 * @params { Object } - ticket results;
	 * @return { Array } - filtered results array;
	 */
	function generateFilteredResult(result) {
		const startValue = vm.ticketNumber.from;
		const endValue = vm.ticketNumber.to;
		const resultTickets = result.tickets.data;
		const resultArray = emptyArrayCreate(startValue, endValue);
		const chunkSize = 80;

		if ( resultTickets.length ) {
			for ( let i = 0, k = resultTickets.length; i < k; i++ ) {
				const match = resultArray.map(function(ticket) {
					return ticket.number;
				})
				.indexOf(parseInt(resultTickets[i].number, 10));

				resultArray[match] = resultTickets[i];
			}
		}

		vm.reportsChunk = _.chunk(resultArray, chunkSize);
		vm.filteredReports = vm.reportsChunk[0];

		// Pagination
		vm.filteredPaginationPage = 1;
		vm.filteredTotalPages = resultArray.length;
		vm.filteredPageSize = 80;

		return vm.filteredReports;
	}

	vm.filteredPagintaion = filteredPagintaion;
	/** */
	function filteredPagintaion(page) {
		vm.filteredReports = vm.reportsChunk[page - 1];
	}

	/** Generates an empty array
	 * @params { Number } - loop start from
	 * @params { Number } - Loop to value
	 * @return { Array } - array of number values between start and end point
	 */
	function emptyArrayCreate(from, to) {
		const emptyArray = [];

		for ( let i = from, k = to; i <= k; i++ ) {
			const serialNumber = { 'number': '' };
			serialNumber.number = i;
			emptyArray.push(serialNumber);
		}

		return 	emptyArray;
	}
}

export default ReportController;



/** WEBPACK FOOTER **
 ** ./client/private/reports/list/list.controller.js
 **/